import devConfig from './config.dev';
import prodConfig from './config.prod';


const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

const config = {
  ...(env === "production" ? prodConfig : devConfig),
  version: "v1.0.19", //latest version
};

export default config;